import { useCalendarDeepLinkCapture } from '../calendar/useCalendarDeepLinkCapture';
import { usePageTracking } from '../hooks/usePageTracking';

/**
 * Mounted once inside BrowserRouter (see src/App.js and src/index.js) so
 * useLocation works. Fires the Meta pixel PageView on every route change.
 *
 * THE-787 — THE HOOK ORDER BELOW IS LOAD-BEARING, do not reorder or split
 * these into sibling mounts. `usePageTracking` fires `fbq('track','PageView')`,
 * and fbevents.js builds its automatic `dl` by reading
 * `document.location.href` itself, inside third-party code we cannot hand a
 * scrubbed value to. A Coming Up holiday card taps through to
 * `/calendar?d=&e=holiday_christmas_2026`, and `/calendar` is lazy — so on that
 * commit the calendar chunk (and THE-784's strip inside it) has not mounted and
 * structurally cannot have cleaned the URL yet. `useCalendarDeepLinkCapture`
 * erases the identifier and stashes it in memory for EventList; effects within
 * one component run in DECLARATION order, so putting it first is what gets it
 * there before the PageView, on a cold load and an SPA navigation alike.
 *
 * THE-788 — this component lives in its own module, apart from App.js, for one
 * reason: so the suite can render THE SHIPPING COMPONENT instead of a replica.
 * `src/theaWeb/calendar/__tests__/deepLinkArrivalPageView.test.tsx` imports it
 * from here, which is what makes the order above observable to CI — swap the
 * two lines and that suite goes red. While it was inlined in App.js the test
 * pinned a hand-written copy, and reordering the real thing stayed green.
 * Do not re-inline it; `src/__tests__/pageTrackingMountIsShared.test.ts` fails
 * the build if App.js declares either hook itself.
 */
export function PageTrackingMount(): null {
  useCalendarDeepLinkCapture();
  usePageTracking();
  return null;
}

export default PageTrackingMount;
